import { createContext, useContext, useState } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { datePreset } from '../../../shared/analytics.js';
import { api } from '../models/api-client.js';
import { queryKeys } from '../models/query-keys.js';

const SessionContext = createContext(null);

export function SessionProvider({ children }) {
  const queryClient = useQueryClient();
  const session = useQuery({ queryKey: queryKeys.session, queryFn: ({ signal }) => api('/api/current_user', { signal }) });
  const config = useQuery({ queryKey: queryKeys.config, queryFn: ({ signal }) => api('/api/config', { signal }), staleTime: Infinity });
  const [filters, setFilters] = useState(() => ({ dates: datePreset(), preset: 'two_weeks', country: 'all', device: 'all' }));
  const [upgradeOpened, setUpgradeOpened] = useState(false);
  const [cancelOpened, setCancelOpened] = useState(false);
  return <SessionContext.Provider value={{
    user: session.data,
    loading: session.isPending,
    error: session.error,
    refreshUser: () => queryClient.invalidateQueries({ queryKey: queryKeys.session }),
    setUser: user => queryClient.setQueryData(queryKeys.session, user),
    config: config.data || {},
    filters,
    setFilters,
    upgradeOpened,
    setUpgradeOpened,
    cancelOpened,
    setCancelOpened,
  }}>{children}</SessionContext.Provider>;
}

export function useSession() {
  return useContext(SessionContext);
}
